import './card-group-section.scss'

import classNames from 'classnames'
import _ from 'lodash'
import React from 'react'

import { withTrans } from '@/i18n/withTrans'

import CardSectionMore from '../card-more/card-section-more'
import Title from '../title/title'
import { TrendingCategoryCard } from './trending-category-card'

const CardSection = ({ title, data, t, i18n, category }) => {
  const range = _.range(data.length + 1)
  return (
    <section className="card-group-section-container">
      <Title title={t(`trending.${title}`)} />
      <div
        className={classNames({
          'box-card-list': true,
          events: category === 'events',
        })}
      >
        {_.map(range, (__, idx) => {
          switch (true) {
            case range.length - 1 === idx:
              return (
                <div className="item-card-list" key={9999}>
                  <CardSectionMore
                    title={t(`trending.${title}`)}
                    category={category}
                    i18n={i18n}
                  />
                </div>
              )
            default:
              return (
                <div className="item-card-list" key={idx}>
                  <TrendingCategoryCard
                    hasNoImage={idx !== 0}
                    item={data[idx].node}
                  />
                </div>
              )
          }
        })}
      </div>
    </section>
  )
}

export default withTrans(CardSection)
